import { render } from "./mcontact.vue?vue&type=template&id=7b0f5522&scoped=true"
import script from "./mcontact.vue?vue&type=script&lang=js"
export * from "./mcontact.vue?vue&type=script&lang=js"

import "./mcontact.vue?vue&type=style&index=0&id=7b0f5522&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0f5522"]])

export default __exports__